import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyClientUISettingsKey, CompanyClientUiSettingsService } from '@shared/services/company-client-ui-settings.service';
import { selectCompany } from '@shared/store/company/company.selectors';
import { filter, take } from 'rxjs/operators';

@Directive({
  selector: '[hasCompanyClientUiSettingsEnabled],[*hasCompanyClientUiSettingsEnabled]',
  standalone: true,
})
export class HasCompanyClientUiSettingsEnabledDirective implements OnInit {
  private readonly templateRef = inject(TemplateRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly companyFeatureService = inject(CompanyClientUiSettingsService);
  private readonly globalStore = inject(Store);

  @Input() hasCompanyClientUiSettingsEnabled: CompanyClientUISettingsKey;

  ngOnInit(): void {
    if (this.hasCompanyClientUiSettingsEnabled) {
      this.globalStore
        .select(selectCompany)
        .pipe(filter(Boolean), take(1))
        .subscribe(() => {
          const isEnabled = this.companyFeatureService.getCompanyUISettingsFeature(this.hasCompanyClientUiSettingsEnabled);
          if (isEnabled) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
          }
        });
    } else {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
